"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_LABEL = void 0;
var events = require("events");
var quoteLabelEventEmitter = new events.EventEmitter();
quoteLabelEventEmitter.setMaxListeners(100);
exports.UPDATE_LABEL = "update label";
exports.default = quoteLabelEventEmitter;
